module.exports = __webpack_public_path__ + "img/bb_g3_t_eyes-03.e2329061.svg";